import { customListSignificantFieldApi } from '../../apis';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { InternalApiCustomListSignificantFields, InternalApiEntityType } from '../../api-internal';

export const useQueryCustomListSignificantFields = (entityType: InternalApiEntityType, enabled = true) => {
  return useQuery({
    queryKey: ['customListSignificantFields', entityType],
    queryFn: () => customListSignificantFieldApi.getSignificantFields({ entityType }),
    enabled,
  });
};

export const useUpdateCustomListSignificantFields = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (significantFields: InternalApiCustomListSignificantFields) =>
      customListSignificantFieldApi.updateSignificantFields({
        internalApiCustomListSignificantFields: significantFields,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customListSignificantFields'] });
    },
  });
};
